import {
  AirOutlined,
  Co2Outlined,
  DeviceThermostatOutlined,
  RouterOutlined,
  Sensors,
  WbSunnyOutlined,
} from "@mui/icons-material";
import {
  blue,
  brown,
  green,
  grey,
  purple,
  red,
  yellow,
} from "@mui/material/colors";
import dayjs from "dayjs";
import { normalizePolygonCoordinates } from "../../utils/geoUtils";
import { isWeatherStation } from "../../config/sensors.config";

export const getSensorIcon = (sensorOrType) => {
  const sensorType =
    sensorOrType?.sensor_type || sensorOrType?.sensorType || sensorOrType;
  const sensorTypeId =
    typeof sensorType === "object" ? sensorType?.id : sensorType;

  if (isWeatherStation(sensorOrType)) {
    return {
      icon: WbSunnyOutlined,
      bgColor: yellow[300],
      iconColor: yellow[700],
    };
  }

  switch (sensorTypeId) {
    case "fb322cf3-b65d-55ff-0f27-5f462674bb21":
      return {
        icon: DeviceThermostatOutlined,
        bgColor: green[300],
        iconColor: green[700],
      };
    case "a2ba8ba0-a480-4b70-bbe5-a920b37f9e9e":
      return {
        icon: AirOutlined,
        bgColor: purple[300],
        iconColor: purple[700],
      };
    case "ab211ca2-b54d-44fa-9a16-4f351563bb10":
      return {
        icon: DeviceThermostatOutlined,
        bgColor: green[300],
        iconColor: green[700],
      };
    case "12e21f97-5e3d-4b44-ba0e-80658912e6b5":
      return {
        icon: Co2Outlined,
        bgColor: brown[300],
        iconColor: brown[700],
      };
    case "0074b23d-8439-457c-8597-60b04ee65333":
      return {
        icon: DeviceThermostatOutlined,
        bgColor: blue[300],
        iconColor: blue[700],
      };
    case "99e43c1d-2ceb-4eef-9f36-fc4d635c61ca":
      return {
        icon: WbSunnyOutlined,
        bgColor: yellow[300],
        iconColor: yellow[700],
      };
    case "gateway":
      return {
        icon: RouterOutlined,
        bgColor: red[300],
        iconColor: red[700],
      };
    default:
      return { icon: Sensors, bgColor: grey[300], iconColor: grey[700] };
  }
};

export const getCurrentCulture = (field_colture) => {
  return field_colture.at(-1);
};

export const isCurrentCulture = (culture) => {
  if (!culture || !culture.end_date) return false;

  const endDate = dayjs(culture.end_date);
  const today = dayjs();

  return endDate.isAfter(today) || endDate.isSame(today);
};

export const calculatePolygonArea = (coords) => {
  const normalizedCoords = normalizePolygonCoordinates(coords);

  if (normalizedCoords.length < 3) {
    return null;
  }

  const first = normalizedCoords[0];
  const last = normalizedCoords[normalizedCoords.length - 1];

  const closedCoords =
    first.lat === last.lat && first.lng === last.lng
      ? normalizedCoords
      : [...normalizedCoords, first];

  const R = 6371000;
  const latRef = closedCoords[0].lat * (Math.PI / 180);

  const xyCoords = closedCoords.map(({ lat, lng }) => {
    const x = R * ((lng * Math.PI) / 180) * Math.cos(latRef);
    const y = R * ((lat * Math.PI) / 180);
    return [x, y];
  });

  let area = 0;
  for (let i = 0; i < xyCoords.length - 1; i++) {
    const [x1, y1] = xyCoords[i];
    const [x2, y2] = xyCoords[i + 1];
    area += x1 * y2 - x2 * y1;
  }

  return Math.abs(area / 2) / 1000000;
};

export const calculatePolygonAreaForArray = (coords) => {
  if (!coords || coords.length < 3) {
    return null;
  }

  const first = coords[0];
  const last = coords[coords.length - 1];
  const closedCoords =
    first[0] === last[0] && first[1] === last[1] ? coords : [...coords, first];

  const R = 6371000;
  const latRef = closedCoords[0][0] * (Math.PI / 180);

  const xyCoords = closedCoords.map(([lat, lon]) => {
    const x = R * ((lon * Math.PI) / 180) * Math.cos(latRef);
    const y = R * ((lat * Math.PI) / 180);
    return [x, y];
  });

  let area = 0;
  for (let i = 0; i < xyCoords.length - 1; i++) {
    const [x1, y1] = xyCoords[i];
    const [x2, y2] = xyCoords[i + 1];
    area += x1 * y2 - x2 * y1;
  }

  return Math.abs(area / 2) / 1_000_000; // in km²
};
